// export useFieldContext for use in your custom components
import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { TextField } from '@app/site/_form/field/TextField';
import { PasswordField } from '@app/site/_form/field/PasswordField';
import { CheckboxField } from '@app/site/_form/field/CheckboxField';
import { SubmitButton } from '@app/site/_form/button/SubmitButton';
import { ResetButton } from '@app/site/_form/button/ResetButton';
import { CountryField } from '@app/site/_form/field/CountryField';
import { SelectField } from '@app/site/_form/field/SelectField';
import { SwitchField } from '@app/site/_form/field/SwitchField';
import { HotelField } from '@app/site/_form/field/HotelField';
import { MultiSelectField } from '@app/site/_form/field/MultiSelectField';
import { CompanyDepartmentField } from '@app/site/_form/field/CompanyDepartmentField';
import { TextAreaField } from '@app/site/_form/field/TextAreaField';
import { RadioField } from '@app/site/_form/field/RadioField';
import { NumberField } from '@app/site/_form/field/NumberField';

export const { fieldContext, formContext, useFieldContext, useFormContext, } =
	createFormHookContexts()

export const { useAppForm, withForm } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {
		TextField,
		TextAreaField,
		PasswordField,
		CheckboxField,
		CountryField,
		HotelField,
		SelectField,
		SwitchField,
		MultiSelectField,
		CompanyDepartmentField,
		RadioField,
		NumberField
	},
	formComponents: {
		SubmitButton,
		ResetButton,
	},
})

export default useAppForm;